import React from "react";
import ControlCProductosSucursalesUI from "./ControlCProductosSucursalesUI";
import { notificarError, notificationSuccess } from "../Almacenes/AlmacenNotify";
import PageError from "../PageError";
import PageLoading from "../PageLoading";
import ProductoService from "../../services/ProductoService";

class ControlCProductosSucursales extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            error: null,
            sucursales: [],
            table: {
                pageSize: 10,
                page: 0,
                sorted: [],
                filtered: [],
                isLoading: false,
                pages: -1,
            },
            filtros: {
                fechaInicio: null,
                fechaFin: null
            },
            modoVista: 'stock',
            diasProyeccion: 30
        };
        this.prodService = new ProductoService();
        this.fetchTimeout = null;
    }

    componentDidMount() {
        this.cargarDatos();
    }

    componentWillUnmount() {
        if (this.fetchTimeout) {
            clearTimeout(this.fetchTimeout);
        }
    }

    cargarDatos = async (modo = this.state.modoVista) => {
        try {
            this.setState({ 
                isLoading: true, 
                modoVista: modo,
                table: { ...this.state.table, isLoading: true } 
            });
            
            const { table, filtros, diasProyeccion } = this.state;
            const params = {
                page: table.page,
                pageSize: table.pageSize,
                sorted: table.sorted,
                filtered: table.filtered
            };

            let resultado;
            
            if (!filtros.fechaInicio || !filtros.fechaFin) {
                resultado = await this.prodService.filtrarSucursalesProds(params);
            } else {
                switch(modo) {
                    case 'stock':
                        resultado = await this.prodService.filtrarSucursalesProds(params);
                        break;
                    case 'balance':
                        resultado = await this.prodService.obtenerBalanceProductos(
                            filtros.fechaInicio,
                            filtros.fechaFin,
                            params
                        );
                        break;
                    case 'predicciones':
                        resultado = await this.prodService.obtenerPrediccionesCompra(
                            filtros.fechaInicio,
                            filtros.fechaFin,
                            diasProyeccion,
                            params
                        );
                        break;
                    case 'abc':
                        resultado = await this.prodService.analisisABCProductos(
                            filtros.fechaInicio,
                            filtros.fechaFin,
                            params
                        );
                        break;
                    default:
                        resultado = await this.prodService.obtenerStockVentasCompras(
                            filtros.fechaInicio,
                            filtros.fechaFin,
                            params
                        );
                }
            }

            this.setState({
                data: resultado.productos || [],
                sucursales: resultado.sucursales || [],
                table: {
                    ...table,
                    pages: resultado.pages || 1,
                    isLoading: false
                },
                isLoading: false,
                analisisExtra: resultado.resumenABC || resultado.proyeccion || null
            });

            if (resultado.productos?.length > 0) {
                notificationSuccess(`${resultado.productos.length} productos encontrados`);
            }

        } catch (error) {
            console.error('Error cargando datos:', error);
            notificarError("Error al cargar los datos");
            this.setState({
                error,
                isLoading: false,
                table: { ...this.state.table, isLoading: false }
            });
        }
    };

    manejarFiltroTabla = (state, instance) => {
        this.setState(
            { table: { ...this.state.table, ...state } },
            () => {
                if (this.fetchTimeout) clearTimeout(this.fetchTimeout);
                this.fetchTimeout = setTimeout(() => {
                    this.cargarDatos();
                }, 300);
            }
        );
    };

    manejarCambioFechas = ({ fechaInicio, fechaFin }) => {
        this.setState(
            { 
                filtros: { fechaInicio, fechaFin },
                table: { ...this.state.table, page: 0 }
            },
            () => {
                this.cargarDatos();
            }
        );
    };

    cambiarModoVista = (modo) => {
        this.setState(
            { modoVista: modo },
            () => this.cargarDatos(modo)
        );
    };

    cambiarDiasProyeccion = (dias) => {
        this.setState(
            { diasProyeccion: dias },
            () => {
                if (this.state.modoVista === 'predicciones') {
                    this.cargarDatos('predicciones');
                }
            }
        );
    };

    render() {
        const { isLoading, error, data, table, sucursales, filtros, modoVista, diasProyeccion, analisisExtra } = this.state;
        
        if (error) {
            return <PageError error={error} />;
        }

        return (
            <div id="productosContainer">
                {isLoading && <PageLoading />}
                <ControlCProductosSucursalesUI
                    onFilterProds={this.manejarFiltroTabla}
                    onFilterChange={this.manejarCambioFechas}
                    onChangePage={(page) => this.setState(
                        { table: { ...table, page } },
                        () => this.cargarDatos()
                    )}
                    onChangePageSize={(pageSize, page) => this.setState(
                        { table: { ...table, pageSize, page } },
                        () => this.cargarDatos()
                    )}
                    tableInfo={table}
                    data={data}
                    sucursales={sucursales}
                    periodo={filtros}
                    isLoading={isLoading}
                    modoVista={modoVista}
                    diasProyeccion={diasProyeccion}
                    analisisExtra={analisisExtra}
                    onCambiarModoVista={this.cambiarModoVista}
                    onCambiarDiasProyeccion={this.cambiarDiasProyeccion}
                    historialService={this.prodService}
                    history={this.props.history}
                />
            </div>
        );
    }
}

export default ControlCProductosSucursales;